package dev.danko.roblox_craft_ai.state

import dev.danko.roblox_craft_ai.uikit.i18n.AppStrings
import dev.danko.roblox_craft_ai.uikit.i18n.LocaleController

val Txt: AppStrings
    get() = LocaleController.strings
